/**
 * Supported BCP 47 tags for language and formatting norms. "es-419" is
 * Latin American Spanish, which keeps the "." decimal separator.
 */
export const GECKO_LOCALES = ['en-US', 'es-419'] as const

export type GeckoLocale = (typeof GECKO_LOCALES)[number]
